var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"","disabled":!_vm.showTooltip},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [(_vm.userId && _vm.userName)?_c('v-avatar',_vm._g(_vm._b({staticClass:"white--text font-weight-medium user-avatar",attrs:{"size":_vm.size,"color":_vm.color}},'v-avatar',attrs,false),on),[_vm._v(" "+_vm._s(_vm.userInitials)+" ")]):_vm._e()]}}])},[_c('span',[_vm._v(_vm._s(_vm.userName))])])}
var staticRenderFns = []

export { render, staticRenderFns }